<template>
  <div style='width:100%;height:100%;position:relative;'>
   <div id='chinaMap' class='map_container'></div>
   <div class='rank-shower' v-if="rankName">
      Top {{rankNumber}}
      <div>
          <span class='rank-dot'></span><span>{{rankName}} </span><span>{{rankData}}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { http } from '@/http'
import echarts from 'echarts'
import 'echarts/chart/map'
// import { option as mapOption } from '@/zjljChartsConfig/mapOption.js' // 中国地图配置
export default{
  props: {
    // productId: {
    //   type: Number,
    //   default: 0
    // },
    countyId: {
      type: Number,
      default: 0
    },
    options: {
      type: Object
    },
    mapColor: {
      type: String,
      default: '#0a2e4e'
    }
  },
  data () {
    return {
      mapHeight: window.innerHeight,
      mapChart: null,
      mapGeo: {}, // 中国地图数据
      lineData: [],
      pointData: [],
      // pointSizes:[60,50,40,30,20,10], //30个分六组点的大小
      sizeIndex: 0,
      mapResponse: {}, // 返回的接口数据
      showPointCount: 30,
      cityLength: 0,
      cityData: [],
      rankName: '',
      rankData: 0,
      rankNumber: 1,
      currentIndex: -1, // 当前的index
      currentCity: {}, // 当前的city对象
      timer: null
    }
  },
  watch: {
    // productId (val) {
    // this.rankName = ''
    // this.currentIndex = -1 // 当前的index
    // this.currentCity = {}
    // this.initPage()
    // }
    $route (to, from) {
      if (to.params && to.params.product_id !== from.params.product_id) {
        this.productId = to.params.product_id
        this.rankName = ''
        this.currentIndex = -1 // 当前的index
        this.currentCity = {}
        this.initPage()
      }
    }
  },
  methods: {
    // 获取地图数据
    getMapData (cb) {
      switch (this.$route.name) {
        case 'gdLitchi': {
          this.productId = this.productId || this.$route.params.product_id || 8048
          break
        }
        case 'sxhlg': {
          this.productId = this.productId || this.$route.params.product_id || 7832
          break
        }
        case 'mmlz': {
          this.productId = this.productId || this.$route.params.product_id || 8048
          break
        }
        case 'zjlj': {
          this.productId = this.productId || this.$route.params.product_id || 8016
          break
        }
        case 'mzyz': {
          this.productId = this.productId || this.$route.params.product_id || 8519
          break
        }
        default: {
          this.productId = this.productId || this.$route.params.product_id
        }
      }
      http.get('/canmou/tianji/product/hot_citys?product_id=' + this.productId + '&county_id=' + this.countyId).then(res => {
        // console.log('res',res)
        this.mapResponse = res.data
        this.cityLength = this.mapResponse.data.items.length
        if (this.mapResponse.status === 0) {
          cb && cb()
        }
      })
    },
    // 跳转显示 每次跳转显示五个点
    jumpMapShow () {
      this.options.series.pop()
      // 设置地图显示的点和线
    },
    initMapOption (mapResponse) {
      // 设置中国地图geoData坐标信息
      let geoCoord = {
        // '上海': [121.4648, 31.2891],
      }
      mapResponse.data.items.forEach(item => {
        geoCoord[item.city_name] = [item.lng, item.lat] // 经度 维度
      })
      this.mapGeo = geoCoord

      // 设置线坐标为一个点 起点终点坐标相同
      let linePoints = mapResponse.data.items.map(geoCoord => {
        return [{ name: geoCoord.city_name }, { name: geoCoord.city_name }]
      })
      this.lineDataStore = linePoints
      // 读取标记点信息
      this.pointDataStore = mapResponse.data.items.map(geoCoord => {
        return { name: geoCoord.city_name }
      })
      this.cityData = mapResponse.data.items
      // this.chinaMapOption=mapOption;
    },
    changeRankShow () {
      this.currentIndex++
      this.currentCity = this.cityData[this.currentIndex]
      this.rankName = this.currentCity.city_name
      this.rankData = this.currentCity.city_uv
      this.rankNumber = this.currentCity.rank

      if (this.currentIndex === this.cityData.length - 1) {
        this.currentIndex = -1
      }
      clearTimeout(this.timer)
      this.timer = setTimeout(() => {
        this.changeRankShow()
      }, 2000)
    },
    initPage () {
      clearTimeout(this.timer)
      if (!this.mapChart) {
        this.mapChart = echarts.init(document.getElementById('chinaMap'))
      } else {
        this.mapChart.clear()
      }
      let mapOption = {
        backgroundColor: 'rgba(255, 255, 255, 0)',
        series: [{
          name: '全国',
          type: 'map',
          roam: true,
          hoverable: false,
          mapType: 'china',
          itemStyle: {
            normal: {
              borderColor: '#666a6d', // 边框颜色
              borderWidth: 2,
              areaStyle: {
                color: this.mapColor // 地图块背景颜色
              }
            }
          },
          data: [],
          // 一些地理位置的坐标
          geoCoord: {
            // '上海': [121.4648, 31.2891],
            // '东莞': [113.8953, 22.901],
            // '东营': [118.7073, 37.5513],
            // '中山': [113.4229, 22.478],
            // '临汾': [111.4783, 36.1615],
          }
        }]

      }

      // let getDrawData=this.getPointPointsAndLine();
      // 改变数据设置动效
      let changeMapPoint = () => {
        // 配置固定数据
        mapOption.series[0].geoCoord = this.mapGeo
        // 配置每一个绘制的项
        this.pointDataStore.forEach((pointItem, pointIndex) => {
          mapOption.series.push(
            {
              name: '',
              type: 'map',
              mapType: 'china',
              data: [],
              markLine: {
                smooth: true,
                effect: {
                  show: true,
                  scaleSize: 1,
                  period: 30,
                  color: '#fff',
                  shadowBlur: 10
                },
                itemStyle: {
                  normal: {
                    borderWidth: 1,
                    lineStyle: {
                      type: 'solid',
                      shadowBlur: 10
                    }
                  }
                },
                data: [
                  this.lineDataStore[pointIndex]
                ]
              },
              markPoint: {
                symbol: 'emptyCircle',
                symbolSize: function (v) {
                  return pointIndex / 30 * 20
                },
                effect: {
                  show: true,
                  shadowBlur: 0
                },
                itemStyle: {
                  normal: {
                    label: { show: false }
                  },
                  emphasis: {
                    label: { position: 'top' }
                  }
                },
                data: [
                  pointItem // 当前标记点数据
                ]
              }
            })
        })
        // 设置
        this.mapChart.setOption(mapOption)
      }
      // 获取数据
      this.getMapData(() => {
        // 处理返回数据
        this.initMapOption(this.mapResponse)
        // 配置固定数据
        //  mapOption.series[0].geoCoord=this.mapGeo;
        // 设置数据切换
        changeMapPoint()
        this.changeRankShow()
      })
    }
  },
  mounted () {
    this.initPage()
  }
}

</script>
<style lang='less' scoped>
  .rank-shower{
    position:absolute;
    left:1100px;
    top:714px;
    border-radius:10px;
    padding:15px;
    box-sizing:border-box;
    z-index:999;
    width:240px;
    height:120px;
    background:#0e213f;
    line-height:45px;
    color:#fff;
    font-size:30px;
  }
  .rank-dot{
    display:inline-block;
    width:30px;
    height:30px;
    border-radius:15px;
    background:red;
    vertical-align:middle;
    margin-right:10px;
  }
  .map_container{
    width: 100%;
    height:100%;
    background:none;
  }
</style>
